<template>
    <div class="clearfix main_center">
        <div class="top-content busWinessLeft">
            <div class="left-navbar">
                <el-button @click="back()" size="small">返回</el-button>
                
            </div>
        </div>
         <div class="right-content clearfix busWinessRight" v-loading.lock="fullscreenLoading">
             <div class="item_top">
                <div class="item_top_title">
                    <span class="title" v-if="dataInfo.bidSectionCode">[{{dataInfo.bidSectionCode}}] </span>
                    <span class="title">{{dataInfo.bidSectionName}}</span>
                    <span class="tag" v-if="dataInfo.qualificationModeName">{{dataInfo.qualificationModeName}}</span>
                    <span class="tag" v-if="dataInfo.tenderModeName">{{dataInfo.tenderModeName}}</span>
                </div>
             </div>
             <div class="my_padding">
                <div class="item_middle">
                    <div>
                        <p>
                            <span class="item_subtitle">审核部门：</span>
                            <span class="content">{{dataInfo.approveDeptName|projectIsEmpty}}</span>
                        </p>
                        <p>
                            <span class="item_subtitle">招标单位：</span>
                            <span class="content">{{dataInfo.tendererName|projectIsEmpty}}</span>
                        </p>
                    </div>
                    <div>
                        <p>
                            <span class="item_subtitle">监督部门：</span>
                            <span class="content">{{dataInfo.superviseDeptName|projectIsEmpty}}</span>
                        </p>
                        <p>
                            <span class="item_subtitle">招标代理：</span>
                            <span class="content">{{dataInfo.tenderAgencyName|projectIsEmpty}}</span>
                        </p>
                    </div>
                    <div>
                        <p>
                            <span class="item_subtitle">开标时间：</span>
                            <span class="content">{{dataInfo.openTime|projectIsEmpty}}
                                <div v-if="dataInfo.passOpenDate>0"></div>
                                <!-- <i v-if="dataInfo.passOpenDate">{{dataInfo.passOpenDate==0?'今日开标':dataInfo.passOpenDate + (dataInfo.passOpenDate > 0?'天前':'天后')}}</i> -->
								<i v-if="dataInfo.passOpenDate>0">{{dataInfo.passOpenDate==0?'今日开标': (dataInfo.passOpenDate > 0?dataInfo.passOpenDate +'天后':'')}}</i>
							</span>
                        </p>
                        <p></p>
                    </div>
                    <div>
                        <span><span style="display:inline-block;width:130px;text-align:right;margin-bottom:5px">时长</span><br><span style="text-align:right;width:130px;font-size:20px;color:#000;font-weight:500;display:inline-block">历时 {{dataInfo.passDate}} 天</span></span>
                    </div>
                </div>
             </div>
            <div class="item_bottom">
				<div class="radioBox">
					<div><span style="background:#1890FF"></span>未超出操作时效范围</div>
                    <div><span style="background:#ffc500"></span>快要超出操作时效范围</div>
                    <div><span style="background:#FF9900"></span>即将超出操作时效范围</div>
					<div><span style="background:#F23030"></span>已超出操作时效范围</div>
					<div><span style="background:#FFFFFF"></span>未到该操作环节</div>
				</div>
				<el-card :key="index"  class="box-card" style="margin-bottom: 10px;" v-for="(item,index) in dataInfo.flownodeList">
                    <div class="line">
                        <div></div>
                    </div>
					<div slot="header" class="clearfix">
						<span>{{item.nodeName}}</span>
					</div>
					<flowCard :itemData="item" :cardWidth="cardWidth"></flowCard>
				</el-card>
            </div>
         </div>
    </div>
</template>

<script>
// import {tabsCloseCurrentHandle} from '@/utils/routeTab';
import flowCard from './compontents/flowCard.vue';
    export default {
        name: "detail",
        data(){
            return{
                businessId:"",
                dataInfo:{},
                cardWidth:0,
                fullscreenLoading:false
            }
            
        },
        components:{
            flowCard
        },
        activated() {

            this.businessId = this.$route.query.businessId || "";
            this.getSingleData()
            this.getCardWidth()

        },
        methods:{
            getCardWidth(){
            this.cardWidth=document.getElementsByClassName('item_bottom')[0]?document.getElementsByClassName('item_bottom')[0].offsetWidth:0
            },
            getSingleData(){
                this.fullscreenLoading=true
                this.$httpReq({
                    url:`/bidSection/getProjectFlowAndEfficacy?businessId=${this.businessId}`,
                    method: 'get',
                }).then(({data}) => {
                    if (data) {
                        if(data.code != '1'){
                            this.$message.error(data.msg)
                            return
                        }
                        this.dataInfo = data.data;
                        this.fullscreenLoading=false
                    }
                })


            },
            back() { // 返回
                tabsCloseCurrentHandle();
                this.$router.push({
                    name: 'flow-efficiency-list',
                })
            },
        }
    }
</script>

<style lang="scss" scoped>
    .item_top{
		padding: 0 15px;
		height: 56px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		.title{
			color: #000000;
			font-size: 14px;
			font-weight: bold;
		}
		.tag{
			color: #1890FF;
			font-size: 12px;
			background: rgba(255, 255, 255, 0.6);
			margin-left: 8px;
			padding: 5px 8px 5px 20px;
			position: relative;
			&:after{
				content: '';
				width: 8px;
				height: 8px;
				position: absolute;
				border: 1px solid #1890FF;
				border-radius: 50%;
				left: 8px;
				top: 50%;
				transform: translate(0,-50%);
			}
		}
		.item_top_time{
			cursor: pointer;
			span{
				color: #000000;
				font-size: 14px;
				font-weight: bold;
				margin-right: 10px;
			}
			img{
				width: 16px;
				margin-top: -5px;

			}
		}
		.zero{
			color: #333333!important;
		}
		.one{
			color: #FF9933!important;
		}
		.two{
			color: #FF0052!important;
		}
	}
	.my_padding{
		padding: 0 25px;
	}
    .item_middle{
		padding: 12px 8px;

		display: flex;
		justify-content: space-between;
		align-items: center;
		&>div{
			flex: 3;
			p{
				// height: 48px;
				height: 17px;
				display: flex;
				justify-content: flex-start;
				align-items: center;
				span{
					font-size: 14px;
					color: #000000;
				}
				.item_subtitle{
					display: inline-block;
					width: 100px;
					text-align: right;
					color: rgba($color: #000000, $alpha: 0.85);
				}
				.content{
					color: rgba($color: #000000, $alpha: 0.65);
					display: inline-block;
					width: calc(100% - 100px);
					display: flex;
					align-items: center;
					div{
						border-style: solid;
						border-width: 13px 12px 13px 0;
						border-color: transparent rgba(245, 107, 108, 0.1) transparent transparent;
						width: 0px;
						height: 0px;
						margin-left: 10px;
					}
					i{
						font-style: normal;
						font-size: 14px;
						color: #F56B6C;
						background: rgba(245, 107, 108, 0.1);
						padding: 5px 15px 5px 8px;
						border-top-right-radius: 20px;
						border-bottom-right-radius: 20px;
					}
				}
			}
		}
		&>div:last-child{
			flex: 1;
			display: flex;
			align-items: center;
			justify-content: flex-end;
			margin-left:auto;
			&>span{
				&:first-child{
					color: #8D8D8D;
				}
			}
			/deep/ .el-dropdown{
				top: 0!important;
				color: #1890FF;
			}
		}
		.content{
			box-shadow: none;
			background: none;
		}
	}
    .item_bottom{
		width: 100%;
		padding: 8px 8px 0 8px;
        height: 100%;
        border-top: 1px solid rgba(0,0,0,.08);
		display: block;
        
		&>div{
			width: 100%;
		}
		.radioBox{
			height: 40px;
			line-height: 40px;
			background: #E6F4FF;
			border: 1px solid #BAE1FF;
			padding-left:20px ;
			display: flex;
			&>div{
				margin-right: 24px;
				margin-left: 17px;
				position: relative;
				span{
					display: inline-block;
					position: absolute;
					width: 12px;
					height: 12px;
					border-radius: 50%;
					top: 14px;
					left: -18px;
				}
			}
		}
        /deep/ .el-card__body{
            padding-top: 34px;
            position: relative;
        }
        .line{
            position:absolute;
            width: 2px;
            height: 34px;
            background: #1890FF;
            top: -2px;
            left: 66px;
            &>div{
                width: 10px;
                height: 10px;
                background: #FFFFFF;
                border: 1px solid #1890FF;
                border-radius: 50%;
                position:absolute;
                top: 29px;
                right: -4px;
            }
        }
    }
</style>